import Button from "../Button/Button.component";
import styles from "./Header.module.scss";
import React, { useEffect, useState } from "react";
import logo from "../../assets/flare-space-logo.svg";
import { FLARE_SPACE_DOMAIN } from "../../constants";
import Footer from "../Footer/Footer.component";
import ConnectWallet from "../ConnectWallet/ConnectWallet.component";
import HelperService from "../../utils/helper.service";
import { useStore } from "../../utils/store.service";

const Header: React.FC = () => {
  const store = useStore();

  return (
    <>
      <div className={styles.header}>
        <div className={styles.background}></div>
        <nav>
          <Button href={FLARE_SPACE_DOMAIN} noStyles={true}>
            <img className={styles.logo} src={logo} alt="flare.space" />
          </Button>
          <aside>
            <flare-space-menu>
              <div>
                <ConnectWallet />
              </div>
              {store.accountConnected.get() && (
                <div
                  className={styles.addressValue}
                  onClick={() =>
                    HelperService.copyAddressToClipboard(store.account.get())
                  }
                >
                  <svg height="20" width="20" viewBox="0 0 48 48">
                    <use
                      href={`${import.meta.env.VITE_BASE_PATH}/images/copy_content.svg#copyIcon`}
                    ></use>
                  </svg>
                </div>
              )}

              <div slot="mobile-footer">
                <Footer mobile={true} />
              </div>
            </flare-space-menu>
          </aside>
        </nav>
      </div>
    </>
  );
};

export default Header;
